import { AES, enc } from 'crypto-js';

const ENCRYPTED_PREFIX = 'pai-enc:';

const getStorageEncryptionKey = key => `pai-ls:${key}`;

const decryptValue = (encryptedValue, key) => {
  const bytes = AES.decrypt(encryptedValue, getStorageEncryptionKey(key));
  const decrypted = bytes.toString(enc.Utf8);
  if (!decrypted) {
    throw new Error('Decryption failed');
  }
  return JSON.parse(decrypted);
};

export const getLocalStorageJson = (key, fallback = null) => {
  if (!key) {
    return fallback;
  }

  try {
    const value = localStorage.getItem(key);
    if (value == null || value === '') {
      return fallback;
    }

    if (value.startsWith(ENCRYPTED_PREFIX)) {
      return decryptValue(value.slice(ENCRYPTED_PREFIX.length), key);
    }

    return JSON.parse(value);
  } catch {
    localStorage.removeItem(key);
    return fallback;
  }
};

export const setLocalStorageJson = (key, value) => {
  if (!key) {
    return;
  }

  const encrypted = AES.encrypt(
    JSON.stringify(value),
    getStorageEncryptionKey(key),
  ).toString();

  localStorage.setItem(key, `${ENCRYPTED_PREFIX}${encrypted}`);
};
